import { MessageTypesUI } from '@/enums/viewEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useSummariesStore } from '@/store/useSummariesStore.ts';
import { useDiscoveryStore } from '@/store/useDiscoveryStore.ts';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { helpers } from '@/helpers.ts';
import { Toast } from '@/components/Toast/Toast.tsx';
import { useLikesListStore } from '@/store/useLikesListStore.ts';
import { routes } from '@/navigation/routes.tsx';

export const handleLikeCreated = (ctxData: WebSocketMessage) => {
  const { incrementLikesCount } = useSummariesStore.getState();
  const { updateCandidateLikesMe } = useDiscoveryStore.getState();
  const { setHasUnreadEvents } = useDialogsStore.getState();
  const { appendLikeFromWS } = useLikesListStore.getState();

  if (ctxData.like_created_event?.contact.hid) {
    incrementLikesCount();
    updateCandidateLikesMe(ctxData.like_created_event?.contact.hid);
    void appendLikeFromWS(ctxData.like_created_event?.contact);

    helpers.toast({
      id: MessageTypesUI.TYPE_LIKE,
      content: (
        <Toast
          type={MessageTypesUI.TYPE_LIKE}
          contact={ctxData.like_created_event?.contact}
        />
      ),
      exclude: [routes.likes]
    });

    setHasUnreadEvents(true);
  }
};
